import { createRouter, createWebHistory, RouterView } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { confirm } from "@/utils/confirm"; // ✅ Add this
import Home from "@/views/Home.vue";
import TourGrid from "@/views/TourGrid.vue";
import Client from "@/views/Client.vue";
import Callback from "@/views/Callback.vue"; // now a real component
import CustomerSetting from "@/views/CustomerSetting.vue";
import AuditGrid from "@/views/AuditGrid.vue";
import UserManager from "@/views/UserManager.vue";

const routes = [
  {
    path: "/",
    name: "Sites",
    component: Home,
    meta: { breadcrumb: "Sites", requiresAuth: true, formName: "Home" },
  },
  {
    path: "/:id/Tours",
    name: "Tours",
    component: TourGrid,
    meta: { breadcrumb: "Tours", requiresAuth: true, formName: "Tours" },
    props: true,
  },
  {
    path: "/sites/:siteId/tours/:tourId/edit",
    name: "TourEditor",
    component: () => import("@/views/TourEditor.vue"),
    meta: { breadcrumb: "Edit Tour", requiresAuth: true, formName: "TourEditor" },
    props: true,
  },
  {
    path: "/customer-settings",
    name: "CustomerSettings",
    component: CustomerSetting,
    meta: { breadcrumb: "Customer Settings", requiresAuth: true, formName: "CustomerSetting" },
  },
  {
    path: "/client",
    name: "Client",
    component: Client,
    meta: { breadcrumb: "Client", requiresAuth: true, formName: "Client" },
  },
  {
    path: "/users",
    name: "Users",
    component: UserManager,
    meta: { breadcrumb: "Users", requiresAuth: true, formName: "UserManager" },
  },
  {
    path: "/tour-progress",
    name: "TourProgress",
    component: () => import("@/views/TourProgress.vue"),
    meta: { breadcrumb: "Tour Progress", requiresAuth: true, formName: "TourProgress" },
  },
  {
    path: "/audit",
    name: "AuditTrail",
    component: AuditGrid,
    meta: { breadcrumb: "Audit Trail", requiresAuth: true, formName: "AuditGrid" },
  },
  { path: "/callback", name: "Callback", component: Callback },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();

  // Allow OIDC callback route to pass without checks
  if (to.name === "Callback") {
    return true;
  }

  await auth.init();

  if (to.meta.requiresAuth && !auth.isAuthenticated) {
    auth.login(to.fullPath);
    return false;
  }

  return true;
});

export default router;
